import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserMailService } from '../../../../service/auth/user-mail.service';

@Component({
  selector: 'app-novo-registro-email',
  templateUrl: './novo-registro-email.component.html',
  styleUrls: ['./novo-registro-email.component.css']
})
export class NovoRegistroEmailComponent {
  form: FormGroup;
  loading = false;
  successMessage = '';
  errorMessage = '';

  constructor(private formBuilder: FormBuilder, private userMailService: UserMailService) {
    this.form = this.formBuilder.group({
      username: ['', [Validators.required, Validators.maxLength(150)]],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  salvar(): void {
    this.successMessage = '';
    this.errorMessage = '';
    this.form.markAllAsTouched();

    if (this.form.invalid || this.loading) {
      return;
    }

    this.loading = true;
    this.userMailService.cadastrar({
      username: this.form.value.username,
      email: this.form.value.email
    }).subscribe(
      () => {
        this.loading = false;
        this.form.reset();
        this.successMessage = 'Registro de e-mail salvo com sucesso.';
      },
      error => {
        this.loading = false;
        this.errorMessage = this.getErrorMessage(error);
      }
    );
  }

  private getErrorMessage(error: any): string {
    return typeof error === 'string' ? error : 'Não foi possível salvar o registro de e-mail.';
  }
}
